import { SVGProps } from 'react';

const Jira = ({ props }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg width="59" height="58" viewBox="0 0 59 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M56.3325 0H28.002C28.002 6.8394 33.7335 12.4064 40.7752 12.4064H46.0155V17.2575C46.0155 24.0969 51.7473 29.664 58.789 29.664V2.38584C58.789 1.03387 57.7246 0 56.3325 0Z"
      fill="#2684FF"
    />
    <path
      d="M42.3346 13.6787H14.0039C14.0039 20.5181 19.7356 26.085 26.7773 26.085H32.0176V31.0158C32.0176 37.8551 37.7494 43.4223 44.7911 43.4223V16.0645C44.7911 14.7921 43.7265 13.6787 42.3346 13.6787Z"
      fill="url(#paint0_linear_218_1660)"
    />
    <path
      d="M28.3308 27.4375H0C0 34.2768 5.73164 39.8437 12.7734 39.8437H18.0138V44.695C18.0138 51.5344 23.7454 57.1013 30.7871 57.1013V29.8232C30.7871 28.4713 29.6409 27.4375 28.3308 27.4375Z"
      fill="url(#paint1_linear_218_1660)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_218_1660"
        x1="44.1884"
        y1="13.7473"
        x2="32.5048"
        y2="26.1524"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_218_1660"
        x1="30.9718"
        y1="27.5289"
        x2="17.4401"
        y2="41.0844"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default Jira;
